import { useEffect, useState } from 'react';

export const useDelayedLoadingFlag = (
  isLoading: boolean,
  delayMs: number
): boolean => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastIsLoading, setLastIsLoading] = useState(isLoading);

  if (lastIsLoading !== isLoading) {
    setLastIsLoading(isLoading);
    if (!isLoading) setIsVisible(false);
  }

  useEffect(() => {
    if (!isLoading) return undefined;
    const timer = window.setTimeout(() => setIsVisible(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [isLoading, delayMs]);

  return isLoading && isVisible;
};
